export const MAP_MISTAKES_API = '/backend/public/v1/mapchanges';

export function submitReport(data) {

//  var coords = ol.proj.transform(coordsM, 'EPSG:3857', 'EPSG:4326');

  return function (dispatch) {

  //  dispatch(requestPosts());

    var dataToSend = {
      info: data.description,
      geometryUrl: data.geometryURL,
      email: data.email,
      name: data.name
    };

    const myRequest = new Request(MAP_MISTAKES_API, {method: 'PUT',  headers: {"Content-Type": "application/json"}, body: JSON.stringify(dataToSend)});

    //dispatch(changeFormState('process'));
    return fetch(myRequest)
      .then((response) => {

          if(response.ok) {
            return dispatch(changeFormState('finished'));
        //  dispatch(mapMistakesEnable(false));
          }
          
          return dispatch(changeFormState('failed'));
        }
      );
  };
}

export const CHANGE_FORM_STATE = 'CHANGE_FORM_STATE'; 
export const changeFormState = data => {
  return {
    type: CHANGE_FORM_STATE,
    state: data
  };
};

export const MAP_MISTAKES_ENABLE = 'MAP_MISTAKES_ENABLE';
export const mapMistakesEnable = data => {
  return {
    type: MAP_MISTAKES_ENABLE,
    data
  };
};

export const START_SENDING = 'START_SENDING'; 
export const startSending = data => {
  return {
    type: START_SENDING,
    data
  };
};



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/mapMistakes/actions.js